(function(){
  /* 24 Oct 2026: "Elevate your experience" cross-sell prices are written by the theme in RM. Mark them as money and ask
     the currency converter (Bucks) to convert them, so visitors outside Malaysia see their own currency like the
     rest of the page. Runs again whenever the theme rewrites a price (variant change). */
  var t;
  function fix(){
    var root=document.querySelector('.product-complementary-section'); if(!root) return;
    var need=false;
    root.querySelectorAll('.save-label').forEach(function(l){ if(l.querySelector('.money')) return; var m=l.textContent.trim().match(/^(save)\s+(\S*\d[\d,.]*)$/i); if(m){ l.innerHTML=m[1]+' <span class="money" data-sg-skip>'+m[2]+'</span>'; need=true; } });
    root.querySelectorAll('.current-price, .old-price, .save-label .money').forEach(function(el){
      var txt=el.textContent.trim(); if(!txt) return;
      if(!el.classList.contains('money')){ el.classList.add('money'); el.setAttribute('data-sg-skip',''); need=true; }
      if(el.classList.contains('buckscc-converted')){
        if(txt===String(el.getAttribute('bucks-current')||'').trim()) return;
        ['bucks-original','bucks-init','bucks-current'].forEach(function(a){ el.removeAttribute(a); }); el.classList.remove('buckscc-converted');
      }
      need=true;
    });
    if(need && window.bucksCC && typeof bucksCC.reConvert==='function'){ try{ bucksCC.reConvert(); }catch(e){} }
  }
  function soon(){ clearTimeout(t); t=setTimeout(fix,80); }
  function start(){ fix(); new MutationObserver(soon).observe(document.body,{childList:true,subtree:true,characterData:true}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
